export const transitionType = {
  Top: '/',
  About: '/#about',
  Stay: '/#stay',
  Food: '/#food',
  Cafe: '/#cafe',
  Access: '/#access',
  Faq: '/#faq',
  Contact: '/#contact',
  ContactPage: '/contact',
  StayContract: 'pdf/stay_contract.pdf',
} as const

export const externalTransitionType = {
  reserve: {
    ja: 'https://reserve.489ban.net/client/amahitotsu/0/plan',
    en: 'https://reserve.489ban.net/client/amahitotsu/4/plan',
  },
  reserve_bbq: {
    ja: 'https://reserve.489ban.net/client/amahitotsu/0/plan/daytrip',
    en: 'https://reserve.489ban.net/client/amahitotsu/4/plan/daytrip',
  }
} as const

export type actionTransitionType =
  typeof transitionType[keyof typeof transitionType]

export const actionTransition = (transition: string) => {
  navigateTo(`${transition}`)
}

export const actionNewTabTransition = (transition: actionTransitionType) => {
  window.open(`/${transition}`, '_blank', 'noopener,noreferrer');
}

export const actionExternalNewTabTransition = (transition: string) => {
  window.open(`${transition}`, '_blank', 'noopener,noreferrer');
}
